<nz-modal [(nzVisible)]="isVisible" [nzContent]="modalContent" [nzFooter]="null" [nzClosable]="false" nzWidth="500px">
  <ng-template #modalContent>
    <div nz-row>
      <div class="popup-title sub-header-font-size">{{'hospital' | translate}}</div>
    </div>
    <div nz-row class="mt-3">
      <div nz-col nzXs="8" nzLg="6" nzXl="6"></div>
      <div nz-col nzXs="8" nzLg="12" nzXl="12">
        <nz-select class="body-font-size" nzShowSearch nzAllowClear nzPlaceHolder="{{'hospitalSelected' | translate}}"
          [(ngModel)]="selectedValue" (ngModelChange)="checkValue()">
          <nz-option class="body-font-size" *ngFor="let item of hospList" [nzLabel]="item.label" [nzValue]="item"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="8" nzLg="6" nzXl="6"></div>
    </div>
    <div nz-row class="mt-4">
      <div nz-col nzSpan="12" class="pr-1">
        <div class="btn-wrapper" style="text-align: right;">
          <div (click)="setData()" class="btn-styles text-center"
            [ngClass]="disabledButton == true?'btn-disable': 'btn-blue'" style="cursor: pointer;">
            <div class="txt">
              <button type="button" class="body-font-size" [disabled]="disabledButton" style="cursor: pointer;">{{'ok' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
      <div nz-col nzSpan="12" class="pl-1">
        <div class="btn-wrapper" style="text-align: left;">
          <div class="btn-styles btn-orange text-center" (click)="logout()" style="cursor: pointer;">
            <div class="txt">
              <button class="body-font-size" type="button" style="cursor: pointer;">{{'cancel' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</nz-modal>